import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RemoteDiagnosticsHelpersService, Snapshot } from '@vi-iot/client';

import { RemoteDiagnosticsSnapshotsStore, SnapshotType } from '@store';

@Component({
  selector: 'app-backup-item',
  templateUrl: './backup-item.component.html',
  styleUrls: ['./backup-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackupItemComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  private snapshotType: SnapshotType;

  @Input() backup: Snapshot;

  installationId: number;
  isSelected = false;

  constructor(
    private remoteDiagnosticsSnapshotsStore: RemoteDiagnosticsSnapshotsStore,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private remoteDiagnosticsHelpersService: RemoteDiagnosticsHelpersService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((param) => {
      this.installationId = param['id'];
    });

    this.remoteDiagnosticsSnapshotsStore.selectedSnapshot$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((backup) => {
        if (!backup || backup.createdAt !== this.backup.createdAt) {
          this.isSelected = false;
        } else {
          this.isSelected = true;
          this.showBackupDetails();
        }

        this.cdr.detectChanges();
      });

    this.remoteDiagnosticsSnapshotsStore.currentSnapshotType$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((type) => {
        this.snapshotType = type;
      });
  }

  showBackupDetails(): void {
    this.remoteDiagnosticsSnapshotsStore.selectSnapshot(this.backup);
    this.remoteDiagnosticsSnapshotsStore.fetchSnapshotDetails(this.installationId, this.backup.id);
    if (this.snapshotType === SnapshotType.SNAPSHOT) {
      this.remoteDiagnosticsSnapshotsStore.clearDateOfTheValuesRead();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.remoteDiagnosticsHelpersService.cancelRequests$.next();
    this.remoteDiagnosticsSnapshotsStore.clearState();
  }
}
